<template>
	<sa-page-layout :btnBackVisible="false" :btnNewVisible="true" :btnRefreshVisible="true" :linkedit="linkedit" :showModalLoading="showModalLoading" @refresh="onRefresh">
		<template slot="table-filter">
			<b-form @submit.prevent="onSubmit">
				<b-row>
					<b-col xs="12" sm="12" md="4" lg="4" xl="4">
						<label class="sa-label-data">Nome</label>
						<b-form-input v-model="attivitaFiltro.nome" type="search" id="nome" placeholder="Nome"></b-form-input>
					</b-col>
					<b-col xs="12" sm="12" md="4" lg="4" xl="4">
						<label class="sa-label-data">Attività</label>
						<!-- <b-form-input v-model="attivitaFiltro.tipoAttivita" type="search" placeholder="Attività"></b-form-input> -->
						<b-form-select v-model="attivitaFiltro.tipoAttivita" :options="tipoAttivitaOptions" :value="null" value-field="descrizione" text-field="descrizione">
							<template #first>
								<b-form-select-option :value="null"> - Seleziona Attivita - </b-form-select-option>
							</template>
						</b-form-select>
					</b-col>

					<b-col xs="12" sm="12" md="2" lg="2" xl="2">
						<label class="sa-label-data">Priorità:</label>
						<b-form-select v-model="attivitaFiltro.descrizionePriorita" :options="tipoPrioritaOptions" :value="''" value-field="descrizione" text-field="descrizione">
							<template #first>
								<b-form-select-option :value="null"> - Seleziona Priorita - </b-form-select-option>
							</template>
						</b-form-select>
					</b-col>
					<b-col xs="12" sm="12" md="2" lg="2" xl="2">
						<label class="sa-label-data">Stato:</label>
						<b-form-select v-model="attivitaFiltro.statoAttuale" :options="statiOptions" :value="''" value-field="stato" text-field="stato">
							<template #first>
								<b-form-select-option :value="null"> - Seleziona Stato - </b-form-select-option>
							</template>
						</b-form-select>
					</b-col>
				</b-row>
				<b-row style="margin-top: 5px">
					<b-col class="sa-padding-right text-right">
						<b-button type="submit" variant="info">{{ this.$i18n.t("global.lblFind") }}</b-button>
						<b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
					</b-col>
				</b-row>
			</b-form>
		</template>
		<template slot="table-body">
			<gestione-attivita-attivita-list-component
				:variabileDitest="FroyNonCiCrede"
				ref="cmpGestioneAttivitaAttivitaListComponent"
				@beforeLoadData="onBeforeLoadDataGestioneAttivitaAttivitaListComponent"
				@afterLoadData="onAfterLoadDataGestioneAttivitaAttivitaListComponent"
			></gestione-attivita-attivita-list-component>
		</template>
	</sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/layout/components/SaPageLayout.vue";
import GestioneAttivitaAttivitaListComponent from "../components/GestioneAttivitaAttivitaListComponent.vue";
import GestioneAttivitaTipiAttivitaMixin from "../mixinis/GestioneAttivitaTipiAttivitaMixin";
import GestioneAttivitaPrioritaMixin from "../mixinis/GestioneAttivitaPrioritaMixin";
import GestioneAttivitaStatiMixin from "../mixinis/GestioneAttivitaStatiMixin";
export default {
	mixins: [GestioneAttivitaTipiAttivitaMixin, GestioneAttivitaPrioritaMixin, GestioneAttivitaStatiMixin],
	components: { SaPageLayout, GestioneAttivitaAttivitaListComponent },
	data() {
		return {
			FroyNonCiCrede: "Kekko ta è Strunz",
			showModalLoading: false,
			linkedit: "attivita",
			attivitaFiltro: { nome: null, tipoAttivita: null, descrizionePriorita: null, statoAttuale: null },
			tipoAttivitaOptions: [],
			tipoPrioritaOptions: [],
			statiOptions: [],
		};
	},
	mounted() {
		let me = this;
		me.$refs.cmpGestioneAttivitaAttivitaListComponent.init(me.attivitaFiltro);
		me.loadAttivitaTipi();
		me.loadDataPriorita();
		me.loadStati();
	},
	methods: {
		onBeforeLoadDataGestioneAttivitaAttivitaListComponent() {
			let me = this;
			me.showModalLoading = true;
		},
		onAfterLoadDataGestioneAttivitaAttivitaListComponent(xxxxx) {
			let me = this;
			me.variabileDitest = xxxxx;
			me.showModalLoading = false;
		},
		onRefresh() {
			let me = this;
			me.$refs.cmpGestioneAttivitaAttivitaListComponent.init(me.attivitaFiltro);
		},
		onSubmit() {
			let me = this;
			me.$refs.cmpGestioneAttivitaAttivitaListComponent.init(me.attivitaFiltro);
		},
		onReset() {
			let me = this;
			me.attivitaFiltro = { nome: null, tipoAttivita: null, descrizionePriorita: null, statoAttuale: null };
			me.$refs.cmpGestioneAttivitaAttivitaListComponent.init(me.attivitaFiltro);
		},
	},
};
</script>

<style></style>
